// Ask ERIO narration voices (ElevenLabs streaming TTS). Curated premade voices.
export const TTS_VOICES = [
  { id: "21m00Tcm4TlvDq8ikWAM", label: "Rachel · calm female" },
  { id: "EXAVITQu4vr4xnSDxMaL", label: "Sarah · clear female" },
  { id: "JBFqnCBsd6RMkjVDRZzb", label: "George · British male" },
  { id: "onwK4e9ZLuTAKqWW03F9", label: "Daniel · news male" },
  { id: "XB0fDUnXU5powFXDhCwa", label: "Charlotte · female" },
  { id: "pNInz6obpgDQGcFmaJgB", label: "Adam · deep male" },
];

export const DEFAULT_VOICE = "21m00Tcm4TlvDq8ikWAM";
const VOICE_KEY = "erio_tts_voice";
const VALID = new Set(TTS_VOICES.map((v) => v.id));

// Validates the stored value so a legacy (OpenAI) voice id migrates to a default.
export const getVoice = () => {
  const v = localStorage.getItem(VOICE_KEY);
  return VALID.has(v) ? v : DEFAULT_VOICE;
};
export const saveVoice = (v) => localStorage.setItem(VOICE_KEY, v);
